import { DeliveryOption } from '../types/communication.types';

// Sets of DeliveryOption values that produce email / SMS messages. Listed as
// data + Array.includes — see REACT_CONVENTIONS.md "Branching code: prefer
// data over `||` chains". The server mirrors these exact membership lists in
// CommunicationService.deliveryOptionRequiresEmail/SMS so the client preview
// and server validation can never disagree.
export const EMAIL_DELIVERY_OPTIONS: DeliveryOption[] = [
  DeliveryOption.EMAIL_ONLY,
  DeliveryOption.EMAIL_PREFERRED,
  DeliveryOption.SMS_PREFERRED,
  DeliveryOption.BOTH
];

export const SMS_DELIVERY_OPTIONS: DeliveryOption[] = [
  DeliveryOption.SMS_ONLY,
  DeliveryOption.EMAIL_PREFERRED,
  DeliveryOption.SMS_PREFERRED,
  DeliveryOption.BOTH
];

export const deliveryOptionRequiresEmail = (option: DeliveryOption): boolean =>
  EMAIL_DELIVERY_OPTIONS.includes(option);

export const deliveryOptionRequiresSMS = (option: DeliveryOption): boolean =>
  SMS_DELIVERY_OPTIONS.includes(option);

// User-friendly label for every template type the backend can stamp on a Communication row.
// The Record<CommunicationType, …> shape makes a newly-added type a build error until labelled.
export const communicationTypeLabels = (sessionTerm: string): Record<CommunicationType, string> => ({
  // Account and access
  PASSWORD_RESET: 'Password Reset',
  USER_INVITE: 'Staff Invitation',
  USER_VERIFICATION: 'Email Verification',
  USER_ADDED_TO_COMPANY: 'Added to Association',
  AUTO_ADD_ADMIN: 'Administrator Added',
  PARENT_LOGIN_CODE: 'Parent Login Code',
  INTRO: 'Welcome to your Account',

  // Evaluation lifecycle
  WELCOME: 'Welcome Email',
  SESSION_START: `${sessionTerm} Start`,
  SESSION_REMINDER: `${sessionTerm} Reminder`,
  SESSION_UPDATE: `${sessionTerm} Update`,
  SESSION_CANCELLED: `${sessionTerm} Cancelled`,
  // Legacy alias for SESSION_UPDATE; still present on historical rows.
  ICE_TIME_UPDATE: `${sessionTerm} Update`,
  HOLD: 'On Hold',
  RSVP_CONFIRMATION: 'RSVP Confirmation',
  CONCLUDE: 'Assessment Concluded',
  CONCLUDE_AA_PLUS: 'Assessment Concluded',
  CONCLUDE_EASTMAN: 'Assessment Concluded',

  // Results
  REPORT_CARD: 'Report Card',
  LEVEL_ASSIGNMENT: 'Level Assigned',
  TEAM_ASSIGNMENT: 'Team Assigned',
  JERSEY_NUMBER: 'Jersey Number Assigned',

  // Evaluator calibration
  CALIBRATION_ASSIGNED: 'Calibration Assigned',
  CALIBRATION_REMINDER: 'Calibration Reminder',
  CALIBRATION_DRIFT_ALERT: 'Calibration Drift Alert',

  // Platform alert to the Max admin team; never shown in an association's history.
  AGE_GROUP_BUCKET_UNRESOLVED: 'Age Group Bucket Unresolved',

  // Ad-hoc rows render their send's title; this is the untitled fallback.
  AD_HOC: 'Custom Message'
});
